// Supplier intelligence on the Negotiation tab (Lane 1354, step S3b; mockup v4): what
// the product already knows about the supplier, one line per source. The server writes
// every sentence from the product's own readers; this only lays them out.
import React, { useEffect, useState } from 'react';

const STATE_CLASS = { ok: '', none: 'srce-mut', off: 'srce-mut', unavailable: 'neg-warn' };

// The sections, one row each: the Negotiation tab and the award screens' supplier
// history pop-up (Lane 1395) show them the same way.
export function IntelFacts({ sections, testPrefix = 'neg-intel' }) {
  return (
    <div className="neg-facts">
      {sections.map((s) => (
        <div key={s.key} className="neg-fact" data-testid={`${testPrefix}-${s.key}`}>
          <span className="neg-k">{s.title}</span>
          <div className={STATE_CLASS[s.state] || ''}>
            {s.lines.map((line, i) => <p key={`${s.key}-${i}`}>{line}</p>)}
            {s.source && <div className="neg-src">{s.source}</div>}
          </div>
        </div>
      ))}
    </div>
  );
}

export default function NegotiationIntel({ api, eventId, supplierId, supplierName, refreshKey }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [tick, setTick] = useState(0);
  useEffect(() => {
    let live = true;
    setData(null);
    setError('');
    api.negotiationIntelligence(eventId, supplierId)
      .then((d) => { if (live) setData(d); })
      .catch((e) => { if (live) setError(e.message); });
    return () => { live = false; };
  }, [api, eventId, supplierId, refreshKey, tick]);
  return (
    <section className="srce-card2" data-testid="neg-intel" aria-labelledby="neg-intel-h" aria-busy={!data && !error}>
      <div className="srce-card2-h">
        <h3 className="srce-card2-t neg-h" id="neg-intel-h">Supplier intelligence</h3>
        <span className="srce-mut srce-ell">{supplierName}</span>
        <span className="srce-pill srce-pill--gray srce-push">Your team only</span>
      </div>
      {error && (
        <div className="srce-error neg-cleared" role="alert">
          {error} <button type="button" className="ll-clr" onClick={() => setTick((t) => t + 1)}>Try again</button>
        </div>
      )}
      <div className="neg-sr" role="status" aria-live="polite">
        {data ? `Supplier intelligence for ${data.supplier_name} loaded.` : ''}
      </div>
      {!data && !error && <div className="ll-loading neg-intel-loading">Loading…</div>}
      {data && <IntelFacts sections={data.sections} />}
    </section>
  );
}
